// extracted by mini-css-extract-plugin
module.exports = {"singleCheckbox":"SingleCheckboxFilter_singleCheckbox__38tbV"};